export default "__VITE_ASSET__glEaRO7I__"